import { render, staticRenderFns } from "./releaseInfo.vue?vue&type=template&id=aafdc71a"
import script from "./releaseInfo.vue?vue&type=script&lang=js"
export * from "./releaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aafdc71a')) {
      api.createRecord('aafdc71a', component.options)
    } else {
      api.reload('aafdc71a', component.options)
    }
    module.hot.accept("./releaseInfo.vue?vue&type=template&id=aafdc71a", function () {
      api.rerender('aafdc71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/releaseInfo.vue"
export default component.exports